// extracted by mini-css-extract-plugin
module.exports = {"searchPage":"search_searchPage__TwVqB","title":"search_title__Lrth5","searchHeader":"search_searchHeader__AK_wd"};